import React from 'react';
import { Download } from 'lucide-react';

const INPUT_CLS = 'w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:border-[#143160] focus:outline-none';

const AREA_OPTIONS = [
  { value: 'hampton_roads', label: 'Hampton Roads' },
  { value: 'outer_banks', label: 'Outer Banks' },
  { value: 'both', label: 'Both Areas' },
];

const AreaPicker = ({ value, onChange }) => (
  <div>
    <label className="block text-sm font-semibold text-gray-700 mb-2">Which area are you interested in?</label>
    <div className="grid grid-cols-3 gap-2">
      {AREA_OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`py-2 px-3 rounded-lg text-sm font-medium transition-all ${value === option.value ? 'bg-[#143160] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
        >
          {option.label}
        </button>
      ))}
    </div>
  </div>
);

const ConsentCheckbox = ({ checked, onChange, onPrivacyClick }) => (
  <div className="flex items-start space-x-3 bg-gold-100 p-3 rounded-xl border border-gold-200">
    <input type="checkbox" id="relocationSmsConsent" className="mt-1 w-4 h-4" checked={checked} onChange={(e) => onChange(e.target.checked)} style={{ accentColor: '#143160' }} />
    <label htmlFor="relocationSmsConsent" className="text-xs text-gray-600 leading-relaxed">
      I agree to be contacted by Jess Sells East Coast via call, email, and text for real estate services. To opt-out, you can reply 'STOP' at any time or reply 'HELP' for assistance. Message and data rates may apply. Message frequency may vary.{' '}
      <button type="button" onClick={onPrivacyClick} className="text-[#143160] underline font-semibold hover:text-gold-600">Privacy Policy</button>.
    </label>
  </div>
);

export const RelocationGuideForm = ({ form, update, onSubmit, submitting, onPrivacyClick }) => (
  <form onSubmit={onSubmit} className="space-y-4" data-testid="relocation-guide-form">
    <input type="text" placeholder="Your Name *" required aria-label="Your name" autoComplete="name" value={form.name} onChange={(e) => update({ name: e.target.value })} className={INPUT_CLS} />
    <input type="email" placeholder="Email Address *" required aria-label="Email address" autoComplete="email" value={form.email} onChange={(e) => update({ email: e.target.value })} className={INPUT_CLS} />
    <input type="tel" placeholder="Phone Number *" required aria-label="Phone number" autoComplete="tel" value={form.phone} onChange={(e) => update({ phone: e.target.value })} className={INPUT_CLS} />
    <AreaPicker value={form.area} onChange={(area) => update({ area })} />
    <ConsentCheckbox checked={form.smsConsent} onChange={(smsConsent) => update({ smsConsent })} onPrivacyClick={onPrivacyClick} />
    <button
      type="submit"
      disabled={submitting}
      data-testid="relocation-guide-submit"
      className="w-full bg-gradient-to-r from-gold-400 to-gold-500 hover:from-gold-500 hover:to-gold-600 text-[#143160] py-4 rounded-xl font-bold text-lg flex items-center justify-center space-x-2 transition-all hover:scale-[1.02] shadow-lg disabled:opacity-70 disabled:cursor-wait disabled:hover:scale-100"
    >
      <Download className="w-5 h-5" />
      <span>{submitting ? 'Sending…' : 'Get My FREE Guide'}</span>
    </button>
    <p className="text-xs text-center text-gray-500">🔒 Your information is secure and will never be sold or shared for marketing purposes.</p>
  </form>
);
